<!-- 资源-选择知识点-吴影茹 -->
<template>
  <div>
    <!-- 标题 -->
    <div class="row_between">
      <div class="resource_select_title">选择知识点</div>
      <a-button @click="reset">换一批</a-button>
    </div>
    <!-- 搜索 -->
    <div class="row_center point_select_box">
      <a-cascader v-model:value="searchValue" :options="options" placeholder="请选择" style="flex: 1" change-on-select />
      <a-button @click="reset">重置</a-button>
      <a-button @click="searchHandler" type="primary">搜索</a-button>
    </div>
    <!-- 列表 -->
    <div class="point_select_box row_wrap">
      <div
        v-for="(item, index) in optionalList"
        :key="index"
        @click="selectHandler(item)"
        :class="isSelected(item) ? 'point_select_act' : 'point_select_off'"
        class="point_select_item"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import { knowledge_list } from '../../composable/knowledge'

const props = defineProps({
  // 已选数据数据
  list: {
    type: Array as () => Array<any>,
    default: () => []
  },
  //   需要传入的教材信息参数
  defaultTextbookData: {
    type: Object,
    default: () => {}
  }
})

onMounted(() => {
  // 随机拉取50个知识点初始化
  changeHandler()
})
const emit = defineEmits(['update:list'])

// 可选知识点列表
const optionalList = ref<any>([])

// 换一批
const changeHandler = () => {
  var shuffled = [...knowledge_list].sort(() => 0.5 - Math.random())
  optionalList.value = shuffled.slice(0, 50)
}

// 是否已选
const isSelected = (item: any) => {
  return selectedList.value.some((i) => i.id === item.id)
}

// 搜索值
const searchValue = ref<any>([])
// 可选搜索-暂时写死
const options = ref<any>([
  {
    value: 1,
    label: '小学',
    children: [
      {
        value: 1,
        label: '语文'
      },
      {
        value: 2,
        label: '数学'
      },
      {
        value: 3,
        label: '英语'
      }
    ]
  },
  {
    value: 2,
    label: '初中',
    children: [
      {
        value: 1,
        label: '语文'
      },
      {
        value: 2,
        label: '数学'
      },
      {
        value: 3,
        label: '英语'
      },
      {
        value: 7,
        label: '政治'
      },
      {
        value: 4,
        label: '物理'
      },
      {
        value: 5,
        label: '化学'
      },
      {
        value: 6,
        label: '生物'
      },
      {
        value: 8,
        label: '历史'
      },
      {
        value: 9,
        label: '地理'
      }
    ]
  },
  {
    value: 3,
    label: '高中',
    children: [
      {
        value: 1,
        label: '语文'
      },
      {
        value: 2,
        label: '数学'
      },
      {
        value: 3,
        label: '英语'
      },
      {
        value: 4,
        label: '物理'
      },
      {
        value: 5,
        label: '化学'
      },
      {
        value: 6,
        label: '生物'
      },
      {
        value: 7,
        label: '政治'
      },
      {
        value: 8,
        label: '历史'
      },
      {
        value: 9,
        label: '地理'
      }
    ]
  }
])

// 搜索
const searchHandler = () => {
  var tempList: any = []

  // 先筛选学段
  if (searchValue.value[0]) {
    tempList = knowledge_list.filter((item) => {
      return item.studyPeriod === searchValue.value[0]
    })
  }

  // 如有学科 再筛选学科
  if (searchValue.value[1]) {
    tempList = tempList.filter((item) => {
      return item.subjectCode === searchValue.value[1]
    })
  }

  optionalList.value = tempList
}

// 重置
const reset = () => {
  searchValue.value = []
  changeHandler()
}

const selectedList = ref<any>([])
// 选择
const selectHandler = (item) => {
  var index = selectedList.value.findIndex((i) => {
    return i.id == item.id
  })
  if (index == -1) {
    selectedList.value.push({ ...item })
  } else {
    selectedList.value.splice(index, 1)
  }

  emit('update:list', selectedList.value)
}

watch(
  () => props.list,
  (newVal) => {
    if (newVal) {
      selectedList.value = newVal.map((item) => {
        return { ...item }
      })
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => props.defaultTextbookData,
  (newVal) => {
    if (newVal && Object.keys(newVal).length != 0) {
      var tempPeriod: any = null
      var tempSubject: any = null
      if (newVal[0]) {
        if (newVal[0] == '2' || newVal[0] == '3') {
          tempPeriod = 1
        } else if (newVal[0] == '4' || newVal[0] == '5') {
          tempPeriod = 2
        } else if (newVal[0] == '8') {
          tempPeriod = 3
        }
      }
      if (
        newVal[2] &&
        (newVal[2] == '1' ||
          newVal[2] == '2' ||
          newVal[2] == '3' ||
          newVal[2] == '4' ||
          newVal[2] == '5' ||
          newVal[2] == '6' ||
          newVal[2] == '7' ||
          newVal[2] == '8' ||
          newVal[2] == '9')
      ) {
        tempSubject = newVal[2]
      }

      searchValue.value = [tempPeriod]
      if (tempSubject) searchValue.value.push(Number(tempSubject))
      searchHandler()
    }
  },
  { immediate: true, deep: true }
)
</script>
            
<style lang="scss" scoped>
.point_select_box {
  margin-top: 20px;
  gap: 15px;
}
.point_select_item {
  padding: 6px 15px;
  border-radius: 50px;
  font-size: 14px;
  cursor: pointer;
}
.point_select_off {
  background-color: #f3f4f6;
  color: #4b5563;
}
.point_select_act {
  background-color: #eff6ff;
  color: #3b82f6;
}
.point_select_off:hover {
  background-color: #eff6ff;
  color: #3b82f6;
}
</style>